/* Agrupación de id_status usada por los KPI del Home. Basado en los estados reales
   que devuelve getCountStatus: 1 Cotizado, 2 Aprobado, 3 Firmado, 4 Validado, 5 Entregado,
   6 No Aprobado, 7 Retirado Reuse, 8 Rechazado, 9 Custodia, 11 En Bodega
   (7/11 son la misma etapa lógica, solo cambia el label según el seller). */
export type TradeinKpiKey = 'cotizados' | 'evaluacion' | 'finalizados'

export const STATUS_GROUPS: Record<TradeinKpiKey, number[]> = {
  cotizados: [1],
  evaluacion: [2, 3, 4],
  finalizados: [5, 6, 7, 8, 9, 11]
}

/* Estados finales negativos: no cuentan para el monto total en retomas vigente. */
export const NEGATIVE_FINAL_STATUS_IDS = [6, 8]

/* Estados que aún no están clasificados en el modelo de negocio (ej. 10 = Caducado):
   se dejan fuera tanto de "Finalizados" como del monto de "Total en retomas" hasta que se definan. */
export const UNCLASSIFIED_STATUS_IDS = [10]

/* Todo lo que se excluye del monto de "Total en retomas": rechazos + no clasificados. */
export const EXCLUDED_FROM_RETOMAS_STATUS_IDS = [...NEGATIVE_FINAL_STATUS_IDS, ...UNCLASSIFIED_STATUS_IDS]
